<div class="field-details-container">
  <div class="header">
    <div class="headline">
      <span class="title">{{ "field.details.title.label" | translate }}</span>
      <span class="subtitle">{{ selectedField?.name }}</span>
    </div>
    <button class="back-button btn-orange-secondary" (click)="deselectField()">
      {{ "field.details.btn.back.label" | translate }}
    </button>
  </div>
  <div class="separator"></div>
  <div class="field-info">
    <div class="info-body">
      @if (selectedField?.area) {
        <div class="info-entry">
          {{
          (selectedField!.area | number : "1.2-2")!
          .replace(",", "")!
          .replace(".", ",")
          }}
          ha
        </div>
      }
      <div class="info-entry">
        <div>{{ "field.details.status.label" | translate }}:</div>
        <div></div>
      </div>
      <div class="info-entry">
        <div>{{ "field.details.seeds.label" | translate }}:</div>
        <div></div>
      </div>
      <div class="info-entry">
        <div>{{ "field.details.fertilizer.label" | translate }}:</div>
        <div></div>
      </div>
      <div class="info-entry">
        <div>{{ "field.details.created.label" | translate }}:</div>
        @if (selectedField?.createdAt) {
          <div>
            {{
            formatDate(selectedField!.createdAt!, "dd.MM.yyyy hh:mm", "en-US")
            }}
          </div>
        }
      </div>
      @if (selectedField?.modifiedAt) {
        <div class="info-entry">
          <div>{{ "field.details.modified.label" | translate }}:</div>
          <div>
            {{
            formatDate(selectedField!.modifiedAt!, "dd.MM.yyyy hh:mm", "en-US")
            }}
          </div>
        </div>
      }
    </div>
    <div class="info-edit">
      <img
        class="edit-icon"
        src="/assets/images/common/icon_pen.svg"
        alt="icon pen"
        (click)="editField()"
        />
      </div>
    </div>

    @if ((scenarioControlAccessible$ | async) === true) {
      <div class="scenario-info">
        <div class="separator"></div>
        <div class="scenario-info-headline">
          {{ "field.details.scenarios.headline" | translate }}
        </div>
        <div class="scenario-info">
          <div class="scenario-list">
            @for (scenario of selectedField?.scenarios; track scenario; let idx = $index) {
              <div
                aria-hidden="true"
                class="scenario-entry-wrapper"
                (click)="selectScenario(scenario)"
                >
                <div class="scenario-entry">
                  <div class="scenario-name">
                    <div class="name">
                      {{ scenario.name }}
                    </div>
                  </div>
                  <!-- shows last modification/createdAt if never modified after that -->
                  @if (scenario?.createdAt && !scenario?.modifiedAt) {
                    <div
                      class="modification-date"
                      >
                      {{ formatDate(scenario?.createdAt!, "dd.MM.yyyy", "en-US") }}
                    </div>
                  }
                  <!-- hh:mm-->
                  @if (scenario?.modifiedAt) {
                    <div class="modification-date">
                      {{ formatDate(scenario?.modifiedAt!, "dd.MM.yyyy", "en-US") }}
                    </div>
                  }
                  <!-- hh:mm-->
                  <!-- <div *ngIf="scenario?.state" class="scenario-status-pill">
                  {{ "field.details.scenarios.state." + scenario.state | translate }}
                </div> -->
              </div>
              <div
            [class]="{
                      'scenario-interactions': true,
                      'scenario-interactions-open': selectedScenario?.id === scenario.id,
                      'scenario-interactions-closed': selectedScenario?.id !== scenario.id,
                    }"
                >
                <!-- if the restrictions on when to show the icons change, it might make sense to show disabled versions instead -->
                @if (
                  selectedScenario?.id === scenario.id &&
                  scenario.state !== 'invalid'
                  ) {
                  <img
                    class="scenario-edit"
                    src="/assets/images/common/icon_pen.svg"
                    alt="icon pen"
                    width="17"
                    height="17"
                    (click)="editScenario()"
                    />
                }
                @if (selectedScenario?.id === scenario.id) {
                  <img
                    class="scenario-delete"
                    src="/assets/images/common/icon_trashcan.svg"
                    alt="icon trashcan"
                    width="12"
                    height="22"
                    (click)="deleteScenario()"
                    />
                }
              </div>
            </div>
          }
          @if (
            !selectedField?.scenarios ||
            (selectedField?.scenarios && selectedField!.scenarios!.length === 0)
            ) {
            <div
              class="no-scenarios"
              >
              {{ "field.details.scenarios.noScenarios" | translate }}
            </div>
          }
        </div>
      </div>
    </div>
  }

  @if ((easyTramAccessible$ | async) === true) {
    <div class="scenario-info">
      <div class="separator"></div>
      <div class="scenario-info-headline" >
        {{ "field.details.easyTram.headline" | translate }}
      </div>
      <div class="scenario-info">
        <div class="scenario-list">
          @for (easyTramPlan of selectedField?.easyTramPlans; track easyTramPlan; let idx = $index) {
            <div
              aria-hidden="true"
              class="scenario-entry-wrapper"
              (click)="selectEasyTramPlan(easyTramPlan)"
              >
              <div class="scenario-entry">
                <div class="scenario-name">
                  <div class="name">
                    {{ easyTramPlan.name }}
                  </div>
                </div>
                <!-- shows last modification/createdAt if never modified after that -->
                @if (easyTramPlan?.createdAt && !easyTramPlan?.modifiedAt) {
                  <div
                    class="modification-date"
                    >
                    {{ formatDate(easyTramPlan?.createdAt!, "dd.MM.yyyy", "en-US") }}
                  </div>
                }
                @if (easyTramPlan?.modifiedAt) {
                  <div class="modification-date">
                    {{ formatDate(easyTramPlan?.modifiedAt!, "dd.MM.yyyy", "en-US") }}
                  </div>
                }
              </div>
              <div
            [class]="{
                      'scenario-interactions': true,
                      'scenario-interactions-open': selectedEasyTramPlan?.id === easyTramPlan.id,
                      'scenario-interactions-closed': selectedEasyTramPlan?.id !== easyTramPlan.id,
                    }"
                >
                <!-- if the restrictions on when to show the icons change, it might make sense to show disabled versions instead -->
                @if (selectedEasyTramPlan?.id === easyTramPlan.id) {
                  <img
                    class="scenario-edit"
                    src="/assets/images/common/icon_zip_file.svg"
                    alt="icon save"
                    width="17"
                    height="17"
                    style="transform: scale(1.1);"
                    (click)="exportEasyTramPlanAsArchive()"
                    />
                }
                @if (selectedEasyTramPlan?.id === easyTramPlan.id) {
                  <img
                    class="scenario-edit"
                    src="/assets/images/common/icon_save.svg"
                    alt="icon save"
                    width="17"
                    height="17"
                    style="transform: scale(1.8);"
                    (click)="exportEasyTramPlan()"
                    />
                }
                @if (selectedEasyTramPlan?.id === easyTramPlan.id) {
                  <img
                    class="scenario-edit"
                    src="/assets/images/common/icon_pen.svg"
                    alt="icon pen"
                    width="17"
                    height="17"
                    (click)="editEasyTramPlan()"
                    />
                }
                @if (selectedEasyTramPlan?.id === easyTramPlan.id) {
                  <img
                    class="scenario-delete"
                    src="/assets/images/common/icon_trashcan.svg"
                    alt="icon trashcan"
                    width="12"
                    height="22"
                    (click)="deleteEasyTramPlan()"
                    />
                }
              </div>
            </div>
          }
          @if (
            !selectedField?.easyTramPlans ||
            (selectedField?.easyTramPlans && selectedField!.easyTramPlans!.length === 0)
            ) {
            <div
              class="no-scenarios"
              >
              {{ "field.details.easyTram.noEasyTramData" | translate }}
            </div>
          }
        </div>
      </div>
    </div>
  }

</div>
